import React from 'react'
import Input from '@UI/antd/Input/Input'
import Form from 'antd/lib/form'
import EyeCloseLineIcon from 'remixicon-react/EyeCloseLineIcon'
import Eye2LineIcon from 'remixicon-react/Eye2LineIcon'
import styles from './index.scss'

// rules can be including:
// 1- { whitespace: true }
// 2- { min: 3 }
// 3- { max: 10 }
// 4- { required: true, message: 'Please enter your name' }

type IProps = {
    label: string
    name: string
    required?: boolean
    requiredMsg?: string
    rules?: any
    theme?: 'round-theme' | ''
}

const InputField = (props: IProps) => {
    const { label = '', name, required = false, requiredMsg = '', rules = [], theme = '' } = props
    const [showPassword, setShowPassword] = React.useState<boolean>(false)
    return (
        <Form.Item
            name={name}
            rules={[
                {
                    required: required,
                    message: requiredMsg || `Please enter your ${name}`
                },
                ...rules
            ]}
            className={`${styles['password-container']} ${styles[theme]}`}
        >
            <Input
                isBlock
                label={label ? label + (required ? ' *' : '') : ''}
                name={name}
                suffix={
                    !showPassword ? (
                        <EyeCloseLineIcon onClick={() => setShowPassword(!showPassword)} size={16} />
                    ) : (
                        <Eye2LineIcon size={16} onClick={() => setShowPassword(!showPassword)} />
                    )
                }
                type={!showPassword ? 'password' : 'text'}
            />
        </Form.Item>
    )
}

export default InputField
